import axios from '@/request';
import qs from 'qs';

const prefix = 'group-xiaoyu';

export default {
  async getList(params: any) {
    return axios.get(`${prefix}/list`, { params });
  },
  async detail(params: any) {
    return axios.get(`${prefix}/info`, { params });
  },
  async cancelBill(params: any) {
    return axios.post(`${prefix}/cancel`, qs.stringify(params));
  },
  async getTotal(params: any) {
    return axios.get(`${prefix}/total`, { params });
  }
};
